import RouteBase from "routes/RouteBase";
import About from "./About";

const Root = (props) => <RouteBase {...props} renderRoute={(p) => <About {...p} />} />;

export default Root;
